import { TypeAdresseTEMPOST } from './TypeAdresseTEMPOST';
import { TypeOuiNon } from './TypeOuiNon';
import { TypeEntite } from '../../typeEntite';

export class TypeFacturation  {
  libelle: TypeAdresseTEMPOST;
  numBonCommande: string;
  noServiceExecutant: string;
  userChorus: TypeOuiNon;
  typeEntite?: TypeEntite;
  identifiantAdressage?: string;
}
